<template>
  <div class="container">
    <!-- 头部导航栏 -->
    <HeaderRegion ref="headerForm" :isShowIndex="5"></HeaderRegion>

    <div id="mainPage">
      <div class="user">
        <!-- 导入用户导航栏 -->
        <div class="user-nav">
          <UserNavigationBar ref="UserFrom"></UserNavigationBar>
        </div>

        <!-- 导入我的收入 -->
        <div class="user-region">
          <myFeedback ref="PriceFrom"></myFeedback>
        </div>
      </div>
    </div>

    <!-- 底部展示区域 -->
    <BottomRegion ref="bottomForm"></BottomRegion>
  </div>
</template>

<script>
  import HeaderRegion from "../../components/headerRegion/headerRegion"; //引入头部导航栏
  import BottomRegion from "../../components/bottomRegion/bottomRegion"; //引入底部展示
  import UserNavigationBar from "../../components/userNavigationBar/userNavigationBar"; //导入用户导航栏
  import myFeedback from "../../components/myFeedback"; //导入我要反馈
  export default {
    name: "myfeedback",
    components: {
      HeaderRegion,
      BottomRegion,
      UserNavigationBar,
      myFeedback,
    },
    data() {
      return {};
    },
    created() {

    },
    methods: {},
 }
</script>

<style scoped>
  .container {
    width: 100%;
  }

  .user {
    width: 1186px;
    margin: 0 auto;
    padding: 27px 0;
    display: flex;
    align-items: flex-start;
  }
  .user-nav {
    display: inline-block;
    /* width: 21.5%; */
    margin: 0 3.5% 0 0;
  }
  .user-region {
    /* width: 75%; */
    width: 900px;
    /*height: 544px;*/
    padding: 10px;
    display: inline-block;
    background-color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/pages/feedback/feedback.vue